export default "__VITE_ASSET__BVNls5LO__"